export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15095.95c540f7.jpg";